/* eslint-disable @typescript-eslint/no-require-imports */
import { Platform } from 'react-native';

const TermsOfServiceScreen =
  Platform.OS === 'web'
    ? require('./terms-of-service.web').default
    : require('./terms-of-service.native').default;

export default TermsOfServiceScreen;
